// @flow

import {
  SET_ACTIVE_FILTER, SET_FILTER_VALUE, SET_FILTER_VALUES, GO_BACK
} from './constants';

import type { State, Action } from '../types';

const initialState: State = {
  currentFilter: null,
  values: {}
};

const reducer = (state: State = initialState, action: Action): State => {
  const { type, filterKey, filterValue }: Action = action;

  switch (type) {
    case SET_ACTIVE_FILTER:
      return {
        ...state,
        currentFilter: filterKey
      };

    case SET_FILTER_VALUE:
      return {
        ...state,
        currentFilter: null,
        values: {
          ...state.values,
          [filterKey]: filterValue
        }
      };

    case SET_FILTER_VALUES:
      return {
        ...state,
        values: action.filterValues
      };

    case GO_BACK:
      return {
        ...state,
        currentFilter: null
      };

    default:
      return state;
  }
};

export default reducer;
